import { Injectable } from '@angular/core';
import { MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { BehaviorSubject } from 'rxjs';
import { PaymentBillItemPendingModel } from '@data-layer/models/payments';
import { DocumentModel } from '@data-layer/models/documents';

@Injectable({ providedIn: 'root' })
export class MarineInsuranceState {
  private currentInsurance$: BehaviorSubject<MarineInsuranceModel> = new BehaviorSubject<MarineInsuranceModel>(null);
  private currentInsurancePendingBills$: BehaviorSubject<PaymentBillItemPendingModel> = new BehaviorSubject<PaymentBillItemPendingModel>(
    null,
  );
  private currentInsuranceDocuments$: BehaviorSubject<DocumentModel> = new BehaviorSubject<DocumentModel>(null);
  private isInsuranceAvailable$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private isProviderWasDown$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isInsuranceLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private isInsuranceUpdated$: BehaviorSubject<void> = new BehaviorSubject<void>(null);

  public shouldShowReminderModal: boolean = false;

  constructor() {}

  public saveData(insurance: MarineInsuranceModel, isAvailable: boolean, isLoading: boolean): void {
    this.currentInsurance$.next(insurance);
    this.isInsuranceAvailable$.next(isAvailable);
    this.isProviderWasDown$.next(insurance?.isProviderWasDown);
    this.isInsuranceLoading$.next(isLoading);
  }

  public saveIsLoadingData(data: boolean): void {
    this.isInsuranceLoading$.next(data);
  }

  public saveBillsData(data: PaymentBillItemPendingModel): void {
    this.currentInsurancePendingBills$.next(data);
  }

  public saveDocsData(data: DocumentModel): void {
    this.currentInsuranceDocuments$.next(data);
  }

  public saveInsuranceUpdatedData(): void {
    this.isInsuranceUpdated$.next();
  }

  public resetData(): void {
    this.currentInsurance$.next(null);
    this.currentInsurancePendingBills$.next(null);
    this.currentInsuranceDocuments$.next(null);
    this.isInsuranceAvailable$.next(true);
    this.isProviderWasDown$.next(false);
    this.isInsuranceLoading$.next(true);
  }

  public get currentInsurance(): BehaviorSubject<MarineInsuranceModel> {
    return this.currentInsurance$;
  }

  public get currentInsurancePendingBills(): BehaviorSubject<PaymentBillItemPendingModel> {
    return this.currentInsurancePendingBills$;
  }

  public get currentInsuranceDocuments(): BehaviorSubject<DocumentModel> {
    return this.currentInsuranceDocuments$;
  }

  public get isInsuranceAvailable(): BehaviorSubject<boolean> {
    return this.isInsuranceAvailable$;
  }

  public get isProviderWasDown(): BehaviorSubject<boolean> {
    return this.isProviderWasDown$;
  }

  public get isInsuranceLoading(): BehaviorSubject<boolean> {
    return this.isInsuranceLoading$;
  }

  public get isInsuranceUpdated(): BehaviorSubject<void> {
    return this.isInsuranceUpdated$;
  }
}
